module.exports = __webpack_public_path__ + "static/media/life-fitness-logo.a140f665.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/life-fitness-logo.png
// module id = 1299
// module chunks = 0